<template>
  <div id="report-video" class="modal fade">
    <div class="modal-dialog feedpost-ensize">
      <div class="modal-content ptrl-3">
        <div class="report-form-fm">
          <label for="video-name" class="mt-3">{{ props_title }}</label>
          <input
            class="form-control"
            type="text"
            :placeholder="$t('common.Report.placeholder')"
            v-model="title"
            maxlength="28"
          />
          <label for="video-typeofreport" class="mt-3">{{ props_type }}</label>
          <select
            class="form-control custom-select select2-no-search"
            v-model="type"
          >
            <option selected value="0">{{$t('common.Report.option')}}</option>
            <option v-for="item in this.reportType" :value="item.val">
              {{ item.txt }}
            </option>
          </select>
          <label for="video-report-reson" class="mt-3">{{
            props_reason
          }}</label>
          <input class="form-control" type="text" v-model="reason" />
          <div class="">
            <button
              type="button"
              class="btn-st-2"
              :title="$t('common.Report.confirm')"
              @click="confirm"
            >
              <span>{{$t('common.Report.confirm')}}</span>
            </button>
          </div>
        </div>
        <!-- /.modal-content -->
      </div>
      <!-- /.modal-dialog -->
    </div>
    <!-- /.modal -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "",
      type: "0",
      reason: "",
      id: 0,
      to_UserName: "",
      sgL_Fav_FType: 0,
      sgL_Fav_FBelongidc: 0,
    };
  },
  props: {
    props_title: { Type: String, default: "檢舉影片標題" },
    props_type: { Type: String, default: "檢舉類型" },
    props_reason: { Type: String, default: "檢舉原因" },
  },
  methods: {
    clearData() {
      this.title = "";
      this.type = "0";
      this.reason = "";
    },
    init(id, to_UserName, sgL_Fav_FType, sgL_Fav_FBelongidc) {
      this.clearData();
      this.show();
      this.id = id;
      this.to_UserName = to_UserName;
      this.sgL_Fav_FType = sgL_Fav_FType;
      this.sgL_Fav_FBelongidc = sgL_Fav_FBelongidc;
    },
    show() {
      $("#report-video").modal("show");
    },
    hide() {
      $("#report-video").modal("hide");
    },
    confirm() {
      let params = {
        sgL_Ttile: this.title,
        sgL_UserName: this.loginUser.displayName,
        sgL_ToUserName: this.to_UserName,
        sgL_Fav_FType: this.sgL_Fav_FType, //图册：0，图片：1，影片：2,活动：3，新闻文字Id：4，社区：5
        sgL_ReportType: this.type,
        sgL_Status: null,
        sgL_PG_Coid: this.id,
        sgL_Fav_FBelongidc: this.sgL_Fav_FBelongidc,
        sgL_ReportContent: this.reason,
        sgL_Remark: "",
      };
      if (this.IsNullOrEmpty(params.sgL_Ttile)) {
        this.$message({ type: "warning", message: "標題不能為空" });
        return;
      }
      this.$api.commons.report(params).then((res) => {
        if (res.data.success) {
          this.$message({ type: "success", message: this.$t('message.operatesuccessfully') });
          this.$emit("reportConfirm");
          this.hide();
          this.clearData();
        } else {
          this.$message({ type: "error", message: res.data.error.message });
        }
      });
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/common/Report.vue